import type { ReactNode } from 'react';
import { useEffect, useRef } from 'react';
import type { GovWizardItemProps } from '@gov-design-system-ce/react';
import { GovWizardItem } from '@gov-design-system-ce/react';
import { scrollToElement } from '@gov-nx/web';

interface WizardItemProps extends Omit<
	GovWizardItemProps,
	'disabled' | 'collapsible'
> {
	children: ReactNode;
	onChange: (status: boolean) => void;

	isDisabled?: boolean;
	isCollapsible?: boolean;
	isFocused?: boolean;
}

export const WizardItem = ({
	children,
	isDisabled,
	isCollapsible,
	isFocused = false,
	...props
}: WizardItemProps) => {
	const stepRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!isFocused) return;

		// TODO: is wizard in the view? If yes, do not scroll...
		const time = setTimeout(() => scrollToElement(stepRef.current), 100);
		return () => clearTimeout(time);
	}, [isFocused]);

	return (
		<GovWizardItem
			ref={stepRef}
			{...props}
			disabled={isDisabled}
			collapsible={isCollapsible}>
			{children}
		</GovWizardItem>
	);
};
